import { Merchant } from '@slerp/controls'
import { message } from 'antd'

export const allowComposerSSO = (merchantSetting: Merchant) => {
  return (
    merchantSetting?.integration_settings?.composer?.enabled &&
    Boolean(merchantSetting?.integration_settings?.composer?.id)
  )
}

export const getComposerEnabled = (merchantSetting: Merchant) => {
  return merchantSetting?.integration_settings?.composer?.enabled || false
}

export const handleComposerSSO = (merchantSetting: Merchant) => {
  if (!merchantSetting?.integration_settings?.composer?.enabled) {
    message.destroy()
    message.error('Composer space not created!')

    return
  }

  const token = localStorage.getItem('token')
  const slug = merchantSetting?.integration_settings?.composer?.id
  const url = `https://${process.env.REACT_APP_COMPOSER_HOST}/api/sso`

  const postParams = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-JWT-Token': `${token}`,
      'Access-Control-Request-Headers': 'Content-Type,X-JWT-Token'
    },
    body: JSON.stringify({ slug: slug })
  }

  message.destroy()
  message.success('Logging in to Composer!')

  fetch(url, postParams)
    .then((response) => response.json())
    .then((data) => {
      if (data.response === 201) {
        window.open(data.sso_url)
      }
    })
    .catch((error) => {
      message.destroy()
      message.error('Unable to login to Composer!')
    })
}
